import { RefreshIcon } from "evergreen-ui";
import React from "react";

interface IProps {
  onClick: any;
  loading?: boolean;
}

const Refresh: React.FC<IProps> = ({ onClick, loading }) => {
  return (
    <div onClick={onClick} className=" cursor-pointer p-2 hover:opacity-60">
      <RefreshIcon className={`${loading && "animate-spin"}`} />
    </div>
  );
};

export default Refresh;
